import { createSlice } from '@reduxjs/toolkit';

interface InitialStateProps {
  list: {
    data: Record<string, any>[] | null;
    total: number | null;
    error: string | null;
    isLoading: boolean;
  };
}

const initialState: InitialStateProps = {
  list: {
    data: null,
    total: null,
    error: null,
    isLoading: false,
  },
};

export const { actions: notificationsActions, reducer: notificationsReducer } = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setNotificationsListRequest: (state) => {
      state.list = {
        data: null,
        total: null,
        error: null,
        isLoading: true,
      };
    },

    setNotificationsListSuccess: (state, { payload }) => {
      state.list = {
        data: payload.hits,
        total: payload.total,
        error: null,
        isLoading: false,
      };
    },

    setNotificationsListFailure: (state, { payload }) => {
      state.list = {
        data: null,
        total: null,
        error: payload,
        isLoading: false,
      };
    },
  },
});
